export const actionsByStatus = (s) => {
    switch (s) {
        case "pendiente":
            return [
                { value: "preparar", label: "Cambiar a PREPARANDO" },
                { value: "cancelar", label: "Cancelar pedido" },
            ];
        case "preparando":
            return [{ value: "enviar", label: "Cambiar a ENVIADO" }];
        case "enviado":
            return [];
        case "entregado":
        case "cancelado":
        default:
            return [];
    }
};